"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _PageHeader = _interopRequireDefault(require("./PageHeader"));
var _PageHeaderTitle = _interopRequireDefault(require("./PageHeaderTitle"));
var _PageHeaderSubTitle = _interopRequireDefault(require("./PageHeaderSubTitle"));
var _PageHeaderTitleMain = _interopRequireDefault(require("./PageHeaderTitleMain"));
var _PageHeaderAction = _interopRequireDefault(require("./PageHeaderAction"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
_PageHeader["default"].Title = _PageHeaderTitle["default"];
_PageHeader["default"].Title.Main = _PageHeaderTitleMain["default"];
_PageHeader["default"].Title.Sub = _PageHeaderSubTitle["default"];
_PageHeader["default"].Action = _PageHeaderAction["default"];
var _default = exports["default"] = _PageHeader["default"];